/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/concat.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Concatenates two or more strings.
 *
 * @example
 * FROM employees
 * | KEEP first_name, last_name
 * | EVAL fullname = CONCAT(first_name, " ", last_name)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'concat',
  signatures: [
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string1',
          type: 'text',
          optional: false,
        },
        {
          name: 'string2',
          type: 'text',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
